import store from '../store';
import axios from 'axios';
import decodeJWT from '../helper/decodeJWT';
import PromiseWithStatus from '../helper/promiseWithStatus';

let tokenUpdating = PromiseWithStatus(new Promise(resolve => resolve()));

export default function defaultRequestInterceptor(interceptor) {
    return async config => {
        // Request interceptor runs on every request (even if it's not
        // explicitly being called through  axios). Becuse of this it will fail
        // making a request through  gapi
        try {
          let token = store.state.user.idToken;
          if (token !== undefined) {
            // removed Bearer because identity toolkit did not like it
            // config.headers.common.Authorization = `Bearer ${ token }`;
            config.headers.common.Authorization = `${ token }`;
            return interceptor(await handleTokenInHeader(config));
          } else {
            return interceptor(config);
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
    };
}

async function handleTokenInHeader(config) {
  const {
    payload: { exp }
  } = decodeJWT(config.headers.common.Authorization);
  let expire = Math.floor(exp - Date.now() / 1000);
  if (expire < 0) {
    return await handleExpiredToken(config);
  } else {
    return config;
  }
}

async function handleExpiredToken(config) {
  if (tokenUpdating.isFulfilled() && !tokenUpdating.isPending()) {
    // This is the first request that needs an updated Authorization token.
    // This will set `tokenUpdating` to a new promise that will resolve the request for the new token.
    reauthorizeToken();
    const idToken = await waitForTokenAndUpdateConfig(config); // wait for the token...
    // removed "Bearer" because identity toolkit did not like it
    // let newToken = `Bearer ${idToken}`;
    let newToken = `${idToken}`;
    axios.defaults.headers.common['Authorization'] = newToken; // Set it for all future requests
    return config;
  } else if (tokenUpdating) {
    // Re-auth is still processing, waiting for token...
    await waitForTokenAndUpdateConfig(config);
    return config;
  }
}

async function waitForTokenAndUpdateConfig(config) {
  const { id_token } = await tokenUpdating;
  // removed "Bearer" because identity toolkit did not like it
  // config.headers.common.Authorization = `Bearer ${id_token}`; // Set it for this request
  config.headers.common.Authorization = `${id_token}`; // Set it for this request
  return id_token;
}

function getRefreshForm() {
  // Google requires the request to be `x-www-form-urlencoded`,
  // not just normal JSON...
  var details = {
    'refresh_token': store.state.user.refreshToken,
    'grant_type': 'refresh_token'
  };

  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  return formBody;
}

function reauthorizeToken() {
  tokenUpdating = PromiseWithStatus(
    new Promise(async resolve => {
      let url = `https://securetoken.googleapis.com/v1/token?key=${process.env.VUE_APP_ROOT_API_KEY}`;
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: getRefreshForm()
      }
      ).then(async (response) => {
        const json = await response.json();
        resolve(json);
      }).catch(() => {
      });
    })
  );
}

axios.interceptors.request.use( defaultRequestInterceptor(config => {
  // Do something before request is sent
  return config;
}),
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);


axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // Do something with response error
    // return new Promise(function () {
    //   if (error.response.status === 400) {
    //     alert("There was a problem.");
    //     window.location.reload();
    //   }
    //   if (error.response.status === 401) {
    //     alert("Session expired, please login again");
    //     window.location.reload();
    //   }
    // });

    if (error.response.status === 401) {
      return new Promise(function () {
        alert("Session expired, please login again");
        window.location.reload();
      });
    } else {
      return Promise.reject(error);
    }
  }
);
